import { TypePessoa } from "@/Models/Pessoa/Pessoa";
import TypeViagem from "../Viagem";
import { Dayjs } from 'dayjs';

export default interface InscricaoDesconto {
    codigo:number;
    codViagem:number;
    viagem:TypeViagem|null;
    codPessoaAluno:number|null;
    pessoaAluno:TypePessoa|null;
    codDocumentoTipo:number|null;
    documento:string|null;
    nomePessoaAluno:string|null;
    codTipoValor:number|EnumTipoValor;
    valor:number;
    ativo:boolean;
    codOperador:number;
    dataCriacao:Date|Dayjs;
}

export enum EnumTipoValor {
    PercValor = 1,
    ValorFixo
}